const TemplateEngines = [
  { id: 'MACRO_MAP', name: 'MACRO_MAP' },
  { id: 'MUSTACHE', name: 'MUSTACHE' }
];

export default TemplateEngines;



// WEBPACK FOOTER //
// ./src/views/Components/CreativeTemplates/StaticData/TemplateEngines.tsx